module.exports = __webpack_public_path__ + "static/media/AcordBCProcesareDate_Credex_20241101_2.2e5e1f6a.pdf";